<template>
<div>
  <WAR :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></WAR>
</div>
</template>

<script>
import WAR from "../../components/WAR-ColumnAlpha";

import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    WAR,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
